import { Theme } from '@mui/material/styles'

import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    padding: theme.spacing(4, 5),
  },
  cppoRoot: {
    display: 'flex',
    gap: theme.spacing(2),
    flexDirection: 'column',
  },
  filterWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: theme.spacing(2),
  },
  authorizationSelector: {
    width: theme.spacing(23.375),
  },
  emptyStateContainer: {
    marginBottom: theme.spacing(4),
  },
  emptyStateContent: {
    marginBottom: theme.spacing(3),
  },
  emptyStateContentLeftSpace: {
    marginLeft: theme.spacing(2),
  },
  waitText: {
    color: 'green',
  },
}))
